import { SESSION_CODE_TABLES, hasSessionCode, sessionEntryByCode } from "shared";

type TableKey = keyof typeof SESSION_CODE_TABLES;

/** ensureSessionCode / セッション読込検証が throw する Error.message の接頭辞（開発者向け） */
export const SESSION_VALIDATION_ERROR_PREFIX = "SESSION_VALIDATION_ERROR:";

/** 一般ユーザ向けエラーページに表示する文言（内部フィールド名は含めない） */
export const SESSION_VALIDATION_USER_MESSAGE =
  "セッション情報を確認できませんでした。お手数ですが再度お手続きください。";

export function isSessionValidationError(error: unknown): error is Error {
  return (
    error instanceof Error &&
    error.message.startsWith(SESSION_VALIDATION_ERROR_PREFIX)
  );
}

/** エラーページ query.message 表示用。内部バリデーション文言はユーザ向け文言に置換する */
export function sanitizeErrorPageDisplayMessage(message: string): string {
  if (message.startsWith(SESSION_VALIDATION_ERROR_PREFIX)) {
    return SESSION_VALIDATION_USER_MESSAGE;
  }
  return message;
}

// コードの妥当性チェック
export function ensureSessionCode(tableKey: TableKey, fieldName: string, code: string): string {
  if (!hasSessionCode(SESSION_CODE_TABLES[tableKey] as Record<string, { code: string }>, code)) {
    console.error("セッションコード不正", { fieldName, code, tableKey });
    throw new Error(`${SESSION_VALIDATION_ERROR_PREFIX} ${fieldName}`);
  }
  return code;
}

/** セッション保存値が AGREEMENT のいずれかであることを検証し、同意済みかどうかを返す（空は未同意扱い） */
export function agreementCheckedFromStored(
  stored: string | undefined | null,
  fieldName: string
): boolean {
  if (stored == null || stored === "") {
    return false;
  }
  ensureSessionCode("AGREEMENT", fieldName, stored);
  return stored === SESSION_CODE_TABLES.AGREEMENT.agreed.code;
}

/** セッション保存値が CONFIRMED のいずれかであることを検証し、確認済みかどうかを返す（空は未確認扱い） */
export function confirmedCheckedFromStored(
  stored: string | undefined | null,
  fieldName: string
): boolean {
  if (stored == null || stored === "") {
    return false;
  }
  ensureSessionCode("CONFIRMED", fieldName, stored);
  return stored === SESSION_CODE_TABLES.CONFIRMED.confirmed.code;
}
